import { t } from 'i18next'
import { AppError } from '#features/ErrorHandling/errorHelpers'

export class AuthenticationError extends AppError {
  constructor(message?: string, error?: unknown, data?: unknown) {
    super(
      t('auth.generic-error.title', {
        ns: 'shared',
        defaultValue: 'Authentication Error',
      }),
      message ?? t('auth.generic-error.message', { defaultValue: 'An error occurred while authenticating.', ns: 'shared' }),
      error,
      data,
    )
  }
}
